<template lang="pug">
  app-modal(v-model="visible" :title="title" :width="500" :confirm-loading="loading" @ok="handleSubmit" @cancel="hide")
    app-form(:model="model" :rules="rules" ref="form" oneline :labelWidth="90")
    
      a-form-model-item(label="仓库" prop="warehouseId" )
        app-remote-select(v-model="model.warehouseId" 
          api="/prj/warehouses/list" :params="params" 
          allow-clear 
          placeholder="请选择仓库"
        )  
      a-form-model-item(label="备注" prop="comments" )
        a-textarea(v-model="model.comments" allow-clear :max-length="100" placeholder="请输入备注")
    
            
        
</template>

<script>
import { GETTER_PROJECT, GETTER_USER } from '@store/account';
import { mapGetters } from 'vuex';
// import InspItemCreateAndEdit from './InspItemCreateAndEdit';

import moment from 'moment';
export default {
  name: 'CreateAndEdit',
  components: {
    // InspItemCreateAndEdit,
  },
  data() {
    return {
      visible: false,
      loading: false,
      title: '添加库存盘点',
      model: {
        warehouseId: null,
        inventoryTotal: null,
        stockingTotal: null,
        varianceTotal: null,
        status: null,
        comments: null,
      },
      rules: {
        warehouseId: [{ required: true, message: '必填项' }],
        // inventoryTotal: [{ required: true, message: '必填项' }],
        // stockingTotal: [{ required: true, message: '必填项' }],
        // varianceTotal: [{ required: true, message: '必填项' }],
        // status: [{ required: true, message: '必填项' }],
        // comments: [{ required: true, message: '必填项' }],
      },
    };
  },
  computed: {
    ...mapGetters({
      project: GETTER_PROJECT,
      user: GETTER_USER,
    }),
    params() {
      return {
        projectId: this.project.id,
      };
    },
  },
  mounted() {},
  methods: {
    moment,
    show(model, action) {
      // this.$refs.form.resetFields();
      this.model = {
        ...this.model,
        ...model,
      };
      this.action = action;
      this.title = model === undefined ? '添加库存盘点' : '编辑库存盘点';
      this.visible = true;
    },
    hide() {
      this.visible = false;
      this.$refs.form.resetFields();
      this.model = {
        warehouseId: null,
        inventoryTotal: null,
        stockingTotal: null,
        varianceTotal: null,
        status: null,
        comments: null,
      };
      // this.$refs.item.handleCancel();
    },
    async handleSubmit() {
      const valid = await this.$refs.form.validate();
      if (valid) {
        this.loading = true;
        this.$restful(
          `save:/prj/stocking`,
          {
            ...this.model,
            projectId: this.project.id,
          },
          { responseType: 'blob' },
        )
          .then((res) => {
            const link = document.createElement('a');
            let blob = new Blob([res], {
              type:
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            link.style.display = 'none';
            link.href = URL.createObjectURL(blob);
            link.setAttribute(
              'download',
              '库存盘点数据导出' +
                this.moment().format('YYYYMMDDHHmmss') +
                '.xlsx',
            );
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.$message.success(this.title + '成功!');
            this.$emit('modal-success');
            this.hide();
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.checkbox-item {
  padding-left: 90px;
  margin: -10px 0 16px 0;
}
.insp-item-list {
}
</style>
